module.exports = __webpack_public_path__ + "img/newLogo.072e8341.svg";